<template>
  <div class="flex flex-col gap-2">
    <label class="flex flex-col">
      <h2 v-if="label" class="flex text-xl font-bold">
        <span class="text-gray-600">{{ label }}</span>
      </h2>
      <slot />
    </label>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>
